/**
 * @typedef {{ target: HTMLElement }} MouseEvent
 * @property { Object } target.dataset
 */

/**
 * @typedef {{ currentTarget: HTMLElement }} InputEvent
 * @property { Array } currentTarget.files
 */